export enum A00210InputCheckboxType {
    A = 'a',
    B = 'b'
}
